import { render, staticRenderFns } from "./HeaderAccountNew.vue?vue&type=template&id=ad1f4fd6&"
import script from "./HeaderAccountNew.vue?vue&type=script&lang=js&"
export * from "./HeaderAccountNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports